import { ReactNode, useMemo } from "react";
import {
  ContractorCardContext,
  ContractorCardContextType,
} from "./ContractorCardContext";
import {
  useContractorCardHandlers,
  useContractorCardLoading,
  useContractorCardError,
} from "../hooks";
import { useContractorCardQuery } from "@/modules/contractor-panel/cards/shared/hooks";

export const ContractorCardProvider = ({
  children,
  contractorCardId,
}: {
  children: ReactNode;
  contractorCardId: string;
}) => {
  const query = useContractorCardQuery(contractorCardId);
  const { contractorCard } = query;

  const {
    handleUpdate,
    handleFileUpload,
    handleView,
    mutations,
    previewDialog,
    handleClosePreview,
  } = useContractorCardHandlers(contractorCardId, contractorCard);
  const { errorState, clearError } = useContractorCardError(
    { contractorCardQuery: query },
    mutations,
  );
  const loadingState = useContractorCardLoading(
    { contractorCardQuery: query },
    mutations,
  );

  const value: ContractorCardContextType = useMemo(
    () => ({
      query,
      data: contractorCard,
      errorState,
      loadingState,
      handleUpdate,
      handleFileUpload,
      handleView,
      clearError,
      refreshContractorCard: query.refetch,
      previewDialog,
      handleClosePreview,
    }),
    [
      query,
      contractorCard,
      errorState,
      loadingState,
      handleUpdate,
      handleFileUpload,
      handleView,
      clearError,
      previewDialog,
      handleClosePreview,
    ],
  );

  return (
    <ContractorCardContext.Provider value={value}>
      {children}
    </ContractorCardContext.Provider>
  );
};
